class BW {
    bits = [];
    writeN(v, n) {
        for (let i = n - 1; i >= 0; i--)
            this.bits.push((v >> i) & 1);
    }
    writeB(b) {
        this.bits.push(b ? 1 : 0);
    }
    toB64u() {
        const bytes = [];
        for (let i = 0; i < this.bits.length; i += 8) {
            let byte = 0;
            for (let j = 0; j < 8 && i + j < this.bits.length; j++)
                byte = (byte << 1) | this.bits[i + j];
            if (i + 8 > this.bits.length)
                byte <<= 8 - (this.bits.length - i);
            bytes.push(byte);
        }
        return Buffer.from(bytes)
            .toString('base64')
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/g, '');
    }
}
class BR {
    bits = [];
    i = 0;
    constructor(b64u) {
        const b64 = b64u.replace(/-/g, '+').replace(/_/g, '/');
        const buf = Buffer.from(b64 + '==='.slice((b64.length + 3) % 4), 'base64');
        for (const byte of buf)
            for (let b = 7; b >= 0; b--)
                this.bits.push((byte >> b) & 1);
    }
    readN(n) {
        let v = 0;
        for (let k = 0; k < n; k++)
            v = (v << 1) | this.bits[this.i++];
        return v;
    }
    readB() {
        return this.readN(1) === 1;
    }
}
export function encodePublisher(m) {
    const w = new BW();
    // Keep a small version header for future evolution
    w.writeN(1, 2); // version = 1 (2 bits)
    for (let p = 1; p <= 12; p++)
        w.writeB(!!m.pubPurposesConsent[p]);
    for (let p = 1; p <= 12; p++)
        w.writeB(!!m.pubPurposesLITransparency[p]);
    return w.toB64u();
}
export function decodePublisher(b64u) {
    const r = new BR(b64u);
    const ver = r.readN(2);
    if (ver !== 1)
        throw new Error(`Unsupported publisher v${ver}`);
    const c = {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false,
        10: false,
        11: false,
        12: false,
    };
    const li = {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false,
        10: false,
        11: false,
        12: false,
    };
    for (let p = 1; p <= 12; p++)
        c[p] = r.readB();
    for (let p = 1; p <= 12; p++)
        li[p] = r.readB();
    return { pubPurposesConsent: c, pubPurposesLITransparency: li };
}
//# sourceMappingURL=publisher.js.map